export const adminInputStyle = {
  width:"100%",
  border:"1px solid black",
  boxShadow:"0 0 10px #6e6e6e4a",
  marginTop:"5px",
  marginBottom:"10px",
  padding:"2px",
}
